import { ReactNode, useContext } from 'react';
import { Can as OriginalCan } from '@casl/react';
import { AbilityContext, AppAbility } from '../../provider/AbilityProvider';

type CanProps = {
  I: Actions;
  a: Subjects;
  field?: string;
  this?: object;
  not?: boolean;
  passThrough?: boolean;
  children:
    | ReactNode
    | ((isAllowed: boolean, ability: AppAbility) => ReactNode);
};

export const useAbility = () => {
  const ability = useContext(AbilityContext);

  const Can = ({ ...props }: CanProps) => {
    return ability ? <OriginalCan ability={ability} {...props} /> : null;
  };

  return { Can, ability };
};
